<section
    [attr.data-testid]="currentTestId() + '-graph'"
    [attr.data-styletarget]="id() + '-graph'"
    [attr.data-uitype]="'graph'"
    class="w-[180px] h-[220px] tablet:h-[250px] absolute bottom-[62px] left-[0px]"
    #graph
></section>
<img
    [attr.data-testid]="currentTestId() + '-image'"
    [attr.data-styletarget]="id() + '-image'"
    [attr.data-uitype]="'image'"
    class="absolute left-0 bottom-0 w-full"
    src="/assets/trendlines/truck-reefer.png"
/>
<div [attr.data-json-info]="'lt-ntl-reefer'" class="hidden">
    {{ data() | json }}
</div>
<meta name="description" [content]="data() | json" />
